// import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useCounter from '../Services/CounterManager';
import fetch from '../api/fetch';

export default function useProxy() {
  const CounterManager = useCounter();
  const navigate = useNavigate();

  function FetchError(status = 500, payload = 'Application error') {
    this.name = 'FetchError';
    this.payload = payload;
    this.status = status;
  }
  FetchError.prototype = Error.prototype;
  return {
    run: (url, method, payload, onSuccess, onFailure, params = {}) => {
      const {
        silent = false,
        redirect,
        mode,
        referrerPolicy,
        doNotStringify,
        preventRedirectToLogin = false,
        signal,
        ...pagingArgs
      } = params;
      let authError = false;
      if (!silent) {
        CounterManager.increment();
      }
      const payloadToSend = !doNotStringify ? JSON.stringify(payload) : payload;

      return fetch(url, {
        method,
        cache: 'no-cache',
        body: method !== 'get' && payloadToSend ? payloadToSend : null,
        redirect: redirect || 'follow',
        mode: mode || 'cors',
        referrerPolicy: referrerPolicy || 'no-referrer-when-downgrade',
        signal,
        ...pagingArgs,
        multipart: doNotStringify,
      })
        .then((response) => {
          const { ok, status } = response;
          //console.log('A', response);
          if (ok) {
            const headers = {};
            for (const [key, value] of response.headers.entries()) {
              headers[key] = value;
            }

            const contentTypes = response.headers?.get('content-type') || '';

            if (
              contentTypes?.includes(
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              )
            ) {
              return response?.blob().then((data) => {
                return {
                  ok,
                  status,
                  headers,
                  data,
                };
              });
            }
            if (
              !contentTypes?.includes('application/json') &&
              !doNotStringify
            ) {
              return {
                ok,
                status,
                headers,
                data: response,
              };
            }
            if (response.status === 204) {
              return {
                ok,
                status,
                headers,
                data: {},
              };
            }

            return response?.json().then((data) => {
              return {
                ok,
                status,
                headers,
                data,
              };
            });
          }
          if (response.status === 401 && !preventRedirectToLogin) {
            authError = true;
          }
          return response.text().then((text) => {
            let result = text;
            try {
              if (text) result = JSON.parse(text);
            } catch {
              result = text;
            }
            return Promise.reject(new FetchError(status, result));
          });
        })
        .then(
          (response) => {
            if (!silent) {
              CounterManager.decrement();
            }
            if (onSuccess) onSuccess(response.data);
            //console.log('B', response);

            return response;
          },
          (error) => {
            if (!silent) {
              CounterManager.decrement();
            }
            if (onFailure) onFailure(error);
            //console.log('C', error);

            if (authError) navigate('/401');
            return error;
          }
        )
        .catch((err) => {
          //console.log('D', err);
          if (onFailure) {
            onFailure(err);
          }
          return err;
        });
    },
  };
}
